import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import React, { useEffect } from "react";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { Box } from "./Box";
import { MainText } from "./MainText";
import { PressableOpacity } from "./PressableOpacity";
import ArrowUpSlider from "../Icons/ArrowSlider/ArrowUpSlider";
import theme from "app/Theme/Theme";

interface Props {
  text: string;
  onPress: () => void;
  isOpen?: boolean;
  openArrowDirection?: number;
}

const DropDownText = ({
  text,
  onPress,
  isOpen = false,
  openArrowDirection = -90,
}: Props) => {
  const arrowRotation = useSharedValue(0);

  const animatedArrowStyle = useAnimatedStyle(() => {
    return {
      transform: [{ rotateZ: `${arrowRotation.value}deg` }],
    };
  });

  useEffect(() => {
    if (isOpen) {
      arrowRotation.value = withTiming(
        isWebDesktop ? openArrowDirection : 180,
        {
          duration: 250,
        },
      );
    } else {
      arrowRotation.value = withTiming(0, { duration: 250 });
    }
  }, [isOpen]);

  return (
    <PressableOpacity onPress={onPress}>
      <Box flexDirection="row" justifyContent="center" alignItems="center">
        <MainText variant="l3-medium" marginRight="xs">
          {text}
        </MainText>
        <Animated.View style={animatedArrowStyle}>
          <ArrowUpSlider color={theme.colors["neutral.900"]} />
        </Animated.View>
      </Box>
    </PressableOpacity>
  );
};

export default DropDownText;
